
/* ===== VELANTIS_LHS_PAGE — ficha de producto de aceites/difusores ===== */
(function(){
  function esc(s){return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function money(n){return '$'+Number(n).toLocaleString('es-MX');}
  var page=document.getElementById('lhsPage');
  var sel={ price:0, ml:'', base:'', img:'oil-ph', kind:'' };
  function reg(){ return window.VELANTIS_LHS||{}; }

  function render(name){
    var p=reg()[name];
    if(!p){ setTimeout(function(){ if(reg()[name]) render(name); else { document.body.classList.remove('lhs'); if(page)page.hidden=true; } },80); return; }
    sel.base=p.name; sel.img=p.img||'oil-ph'; sel.kind=p.kind;
    document.getElementById('lhsBack').setAttribute('href', p.kind==='ambiental' ? '#/ambientales' : (p.kind==='difusor'||p.kind==='aroma' ? '#/difusores' : '#/aceites'));
    document.getElementById('lhsImg').className='lhs-img '+(p.img||'oil-ph');
    document.getElementById('lhsEyebrow').textContent=p.eyebrow||'';
    document.getElementById('lhsName').textContent=p.name;
    document.getElementById('lhsDesc').textContent=p.long||p.desc||'';
    var opt=document.getElementById('lhsOptions'), price=document.getElementById('lhsPrice');
    var giftBtn=document.getElementById('lhsGiftBtn'), giftNote=document.getElementById('lhsGiftNote');
    var giftMode=false; try{giftMode=localStorage.getItem('velantis_oilgift')==='1';}catch(e){}
    sel.gift=false;
    if(p.kind==='difusor'){
      /* 3-sep: el difusor se cobra por aroma incluido. Si el mapa trae la lista
   (cx.difusorAromas), la ficha la ofrece como pastillas y el carrito lo
   nombra «<difusor> · <aroma>», que es la llave con la que se cobra. */
 var CXD={}; try{ CXD=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){}
 var aromas=(CXD.difusorAromas||{})[p.name]||[];
 sel.aroma=aromas[0]||'';
 var aromH=aromas.length? '<div class="lhs-sizes"><div class="lhs-sizes-l">Elige el aroma incluido</div><div class="lhs-pills lhs-pills-aroma">'+
   aromas.map(function(a,i){ return '<button type="button" class="lhs-pill'+(i===0?' on':'')+'" data-aroma="'+esc(a)+'">'+esc(a)+'</button>'; }).join('')+'</div></div>' : '';
 opt.innerHTML=aromH+'<ul class="lhs-specs">'+(p.specs||[]).map(function(s){return '<li>'+esc(s)+'</li>';}).join('')+'</ul>';
 if(aromas.length && CXD.precios && CXD.precios[p.name+' · '+sel.aroma]!=null) p.price=+CXD.precios[p.name+' · '+sel.aroma];
 else if(CXD.precios && CXD.precios[p.name]!=null) p.price=+CXD.precios[p.name]; /* 4-sep: difusor sin aromas, precio del mapa */
      sel.price=p.price||1500; sel.ml='';
      price.innerHTML=money(sel.price)+' <small>MXN</small>';
      if(giftBtn) giftBtn.hidden=true; if(giftNote) giftNote.hidden=true;
      document.getElementById('lhsAdd').textContent='Agregar al carrito';
    } else if(p.kind==='ambiental'){
      if(giftBtn) giftBtn.hidden=true; if(giftNote) giftNote.hidden=true;
      var pyrH='';
      if(p.pyr && p.pyr.some(function(x){return x;})){ var tr=[['Salida',0],['Corazón',1],['Fondo',2]];
        pyrH='<div class="lhs-pyr">'+tr.map(function(t){return p.pyr[t[1]]?'<div class="lhs-pyr-row"><span class="lhs-pyr-l">'+t[0]+'</span><span class="lhs-pyr-n">'+esc(p.pyr[t[1]])+'</span></div>':'';}).join('')+'</div>'; }
      opt.innerHTML=pyrH+'<div class="lhs-ml250">Aroma de ambiente · 250&nbsp;ml · con feromonas incluidas</div>';
      /* 4-sep: precio del mapa por nombre exacto; 449 solo si el mapa no lo trae */
      var CXA={}; try{ CXA=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){}
      sel.price=(CXA.precios && CXA.precios[p.name]!=null)? +CXA.precios[p.name] : 449; sel.ml='250 ml';
      price.innerHTML=money(sel.price)+' <small>MXN</small>';
      document.getElementById('lhsAdd').textContent='Agregar al carrito';
    } else {
      if(giftBtn) giftBtn.hidden=true;
      var sizes=p.sizes||[['100 ml',450],['250 ml',900],['1 L',2200]];
      /* 4-sep: los tamanos del aceite toman su precio del mapa vivo («<nombre> · Aceite <tamano>»); la tabla fija queda de respaldo */
      (function(){ var CXO={}; try{ CXO=JSON.parse(document.getElementById('pc-conexion').textContent)||{}; }catch(e){} var P=CXO.precios||{};
        sizes=sizes.map(function(sz){ var v=P[p.name+' · Aceite '+sz[0]]; return v!=null? [sz[0],+v] : sz; }); })();
      if(giftMode){ sizes=[['100 ml',0]]; sel.gift=true; }
      var notesHTML='';
      if(p.pyr && p.pyr.some(function(x){return x;})){
        var tiers=[['Salida',0],['Corazón',1],['Fondo',2]];
        notesHTML='<div class="lhs-pyr">'+tiers.map(function(t){ return p.pyr[t[1]]?'<div class="lhs-pyr-row"><span class="lhs-pyr-l">'+t[0]+'</span><span class="lhs-pyr-n">'+esc(p.pyr[t[1]])+'</span></div>':''; }).join('')+'</div>';
      } else if(p.notes){ notesHTML='<div class="lhs-notes"><span class="lhs-notes-l">Notas</span>'+esc(p.notes)+'</div>'; }
      opt.innerHTML=notesHTML+'<div class="lhs-sizes"><div class="lhs-sizes-l">'+(sel.gift?'Tu regalo':'Elige tu tamaño')+'</div><div class="lhs-pills">'+
        sizes.map(function(s,i){return '<button type="button" class="lhs-pill'+(i===0?' on':'')+'" data-price="'+s[1]+'" data-ml="'+esc(s[0])+'">'+esc(s[0])+'<span>'+(sel.gift?'GRATIS':money(s[1]))+'</span></button>';}).join('')+'</div></div>';
      sel.price=sizes[0][1]; sel.ml=sizes[0][0];
      if(sel.gift){
        price.innerHTML='GRATIS <small>· 100&nbsp;ml de regalo</small>';
        if(giftNote){ giftNote.hidden=false; giftNote.innerHTML='🎁 Estás eligiendo tu <b>aceite de regalo</b> (100&nbsp;ml gratis) por la compra de tu difusor. Selecciónalo y agrégalo.'; }
        document.getElementById('lhsAdd').textContent='Agregar aceite de regalo';
      } else {
        price.innerHTML=money(sel.price)+' <small>MXN</small>';
        if(giftNote) giftNote.hidden=true;
        document.getElementById('lhsAdd').textContent='Agregar al carrito';
      }
    }
    // acordeón
    document.getElementById('lhsAcc').innerHTML=
      (p.areas? acc('Áreas recomendadas', p.areas) : '')+
      acc('Envíos y devoluciones','Envío a todo México. Preparamos tu pedido en 24–48 h. Cambios dentro de los primeros 7 días con el producto sin abrir.');
    window.scrollTo(0,0);
  }
  function acc(t,b){ return '<div class="lhs-ai"><button class="lhs-ai-h" type="button">'+esc(t)+'<span>+</span></button><div class="lhs-ai-b">'+esc(b)+'</div></div>'; }

  // interacción: pills, acordeón, agregar
  page.addEventListener('click',function(e){
    var pa=e.target.closest('.lhs-pill[data-aroma]');
 if(pa){ [].forEach.call(page.querySelectorAll('.lhs-pill[data-aroma]'),function(x){x.classList.remove('on');}); pa.classList.add('on'); sel.aroma=pa.getAttribute('data-aroma'); return; }
 var pill=e.target.closest('.lhs-pill');
    if(pill){ [].forEach.call(page.querySelectorAll('.lhs-pill'),function(x){x.classList.remove('on');}); pill.classList.add('on');
      sel.price=+pill.getAttribute('data-price'); sel.ml=pill.getAttribute('data-ml');
      document.getElementById('lhsPrice').innerHTML=(sel.gift?'GRATIS <small>· 100&nbsp;ml de regalo</small>':money(sel.price)+' <small>MXN</small>'); return; }
    var ah=e.target.closest('.lhs-ai-h'); if(ah){ ah.parentNode.classList.toggle('open'); return; }
    if(e.target.closest('#lhsGiftBtn')){ try{localStorage.setItem('velantis_oilgift','1');}catch(e){} location.hash='#/aceites'; return; }
    if(e.target.closest('#lhsAdd')){
      if(sel.gift){
        if(window.VelantisCart) window.VelantisCart.add({name:sel.base+' · Aceite 100 ml (Regalo)', price:0, img:sel.img, sub:'Aceite de regalo · 100 ml · por tu difusor'});
        try{localStorage.removeItem('velantis_oilgift');}catch(e){}
        document.getElementById('lhsAdd').textContent='¡Regalo agregado! ✓';
        if(window.VelantisCart&&window.VelantisCart.open) window.VelantisCart.open();
        return;
      }
      var name=sel.kind==='difusor'? (sel.aroma? sel.base+' · '+sel.aroma : sel.base) : (sel.kind==='ambiental'? sel.base : (sel.base+' · Aceite '+sel.ml));
      var sub=sel.kind==='difusor'? ('Difusor · aroma incluido'+(sel.aroma?': '+sel.aroma:'')) : (sel.kind==='ambiental'? 'Aroma de ambiente · 250 ml' : ('Aceite para difusor · '+sel.ml));
      if(window.VelantisCart) window.VelantisCart.add({name:name, price:sel.price, img:sel.img, sub:sub});
      var b=document.getElementById('lhsAdd'), t=b.textContent; b.textContent='Agregado ✓'; setTimeout(function(){b.textContent=t;},1400);
    }
  });

  function route(){
    var hs=location.hash||'';
    var isL=hs.indexOf('#/lhs/')===0;
    document.body.classList.toggle('lhs',isL);
    if(page) page.hidden=!isL;
    if(isL){ render(decodeURIComponent(hs.slice('#/lhs/'.length))); }
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
